import { ADJUSTMENT_TYPE } from '@/const/types/adjustment';

export const ADJUSTMENT_MAP = {
    [ADJUSTMENT_TYPE.FREE]: '무료',
    [ADJUSTMENT_TYPE.CPM]: 'CPM',
    [ADJUSTMENT_TYPE.CPC]: 'CPC',
}
export const ADJUSTMENT_SELECT = (() => {
    return Object.keys(ADJUSTMENT_MAP).map((key: any) => {
        return {
            label: ADJUSTMENT_MAP[key as ADJUSTMENT_TYPE],
            value: Number.parseInt(key),
        }
    })
})();